/*
 * SOP页面
 */
<template>
  <div class="common-container">
    <v-navigation-drawer class="my-3 drawer-fix"
                         floating
                         permanent>
      <v-list class="d-flex pa-0">
        <template v-for="item in items">
          <v-list-tile :key="item.title"
                        class="tabs-route"
                       :class="(item.tile === paths) ? 'tab-route-active' : ''"
                       @click="turnPage(item)">
            <v-list-tile-content>
              <v-list-tile-title >{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-navigation-drawer>
    <router-view></router-view>
  </div>
</template>

<script>
import { RecordUserBehavior } from '@/api/classtable.js'
import { formatDate } from '@/utils/date'

export default {
  data: () => ({
    items: [
      {
        title: 'SOP Score/class',
        tile: 'scoreClass',
        icon: 'sentiment_dissatisfied'
      },
      {
        title: 'SOP Assessment Summary',
        tile: 'assessmentSummary',
        icon: 'alarm_off'
      }
    ]
  }),
  computed: {
    paths: function () {
      return this.$route.fullPath.split('/').pop()
    }
  },
  methods: {
    async turnPage (e) {
      if(e.tile == 'assessmentSummary'){
        const r_data = {
          userId: this.$store.state.user.tuid,
          startTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
          endTime: formatDate(new Date(), 'yyyy-MM-dd hh:mm:ss'),
          labelId: 427
        }
        await RecordUserBehavior(r_data).then(res => {
          console.log(res);
        }).catch(err => {
            console.log('请求失败: ' + err.message);
        })
      }
      this.$router.push({ path: `/SOP/${e.tile}` })
    },
    formatDate(date){
      return formatDate(date,'MM-dd-yyyy');
    },
  }
}
</script>
<style lang="sass" scoped>
  // @import "./complaintList"
</style>

